import React, { useEffect } from 'react';
import styles from './DeviceWarning.module.css';
import PineappleLogo from '../../../images/logo/pineapple-logo-black-text.png';

interface DeviceWarningProps {
    onDismiss: () => void;
}

const DeviceWarning: React.FC<DeviceWarningProps> = ({ onDismiss }) => {
    // Prevent body scroll when modal is mounted
    useEffect(() => {
        // Save current scroll position
        const scrollY = window.scrollY;

        // Prevent scrolling
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';

        // Cleanup on unmount - restore scrolling
        return () => {
            const savedScrollY = document.body.style.top;
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';

            // Restore scroll position
            if (savedScrollY) {
                window.scrollTo(0, parseInt(savedScrollY || '0') * -1);
            }
        };
    }, []);

    return (
        <div className={styles.overlay}>
            <div className={styles.dialogContainer}>
                {/* Animated Background Circles */}
                <div className={styles.backgroundCircle1}></div>
                <div className={styles.backgroundCircle2}></div>

                {/* Logo Section */}
                <div className={styles.logoSection}>
                    <img
                        src={PineappleLogo}
                        alt="Pineapple Logo"
                        className={styles.logo}
                        width={240}
                        height={80}
                    />
                </div>

                {/* Icon Section */}
                {/* <div className={styles.iconSection}>
                    <div className={styles.iconWrapper}>
                        <MonitorIcon width={64} height={64} color="#51ab86" />
                    </div>
                </div> */}

                {/* Content Section */}
                <div className={styles.contentSection}>
                    <h2 className={styles.title}>Desktop Experience Recommended</h2>
                    <p className={styles.message}>
                        For the best experience, please access this portal on a desktop device.
                    </p>
                </div>

                {/* Action Button */}
                <div className={styles.actionSection}>
                    <button
                        className={styles.continueButton}
                        onClick={onDismiss}
                    >
                        Continue Anyway
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeviceWarning;

